import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import {
	allRoutes
} from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
	// vue-meta用来查找meta信息的组件选项名称。
	keyName: 'page',
})

const router = new VueRouter({
	routes: allRoutes,
	//使用HTML5的历史API(即普通外观的路由)

	//而不是使用散列的路由(例如example.com/#/about)。

	//这可能需要一些服务器配置在生产:

	// https://router.vuejs.org/en/essentials/history-mode.html example-server-configurations
	mode: 'history',
	//在导航到一个新控件时，模拟类似本机的滚动行为

	//路由和使用后退/前进按钮。
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
})

// 在每个路由评估…
router.beforeEach((routeTo, routeFrom, next) => {
	// 如果这不是一个初始页面加载…
	if (routeFrom.name !== null) {
		// 启动路由进度条。
		NProgress.start()
	}

	//检查该路由是否需要auth

	//包含嵌套路由。
	const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
	//如果该路由不需要auth，则继续。
	if (!authRequired) return next()
	// console.log(store.getters['auth/loggedIn'])
	//如果需要auth并且用户已经登录…
	if (store.getters['auth/loggedIn']) {
		return next()
		//验证本地用户令牌…
		// return store.dispatch('auth/validate').then((validUser) => {
		// 	//如果token仍然代表一个有效的用户，则继续
		// 	console.log(validUser)
		// 	//否则重定向到登录。
		// 	validUser ? next() : redirectToLogin()
		// })
	}

	//如果需要验证，且用户当前未登录，

	//重定向到登录。
	redirectToLogin()

	function redirectToLogin() {
		//将原始路由传递给登录组件
		next({
			name: 'login',
			query: {
				redirectFrom: routeTo.fullPath
			}
		})
	}
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
	// Create a `beforeResolve` hook, which fires whenever
	// `beforeRouteEnter` and `beforeRouteUpdate` would. This
	// allows us to ensure data is fetched even when params change,
	// but the resolved route does not. We put it in `meta` to
	// indicate that it's a hook we created, rather than part of
	// Vue Router (yet?).
	try {
		// For each matched route...
		for (const route of routeTo.matched) {
			await new Promise((resolve, reject) => {
				// If a `beforeResolve` hook is defined, call it with
				// the same arguments as the `beforeEnter` hook.
				if (route.meta && route.meta.beforeResolve) {
					route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
						// If the user chose to redirect...
						if (args.length) {
							// If redirecting to the same route we're coming from...
							if (routeFrom.name === args[0].name) {
								// Complete the animation of the route progress bar.
								NProgress.done()
							}
							// Complete the redirect.
							next(...args)
							reject(new Error('Redirected'))
						} else {
							resolve()
						}
					})
				} else {
					// Otherwise, continue resolving the route.
					resolve()
				}
			})
		}
		// If a `beforeResolve` hook chose to redirect, just return.
	} catch (error) {
		return
	}

	// If we reach this point, continue resolving the route.
	next()
})

// When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {
	// Complete the animation of the route progress bar.
	NProgress.done()
})

export default router
